// extracted by mini-css-extract-plugin
export default {"iconBtn":"styles_iconBtn__rZ9NX","icon":"styles_icon__Xbv80","closeBtn":"styles_closeBtn__o69j+"};